<template>
  <div class="w-full flex flex-row justify-center bg-themeComponentBg-light font-rubik cover-cards-outer-container">
    <div class="w-full max-w-1440 cover-cards-container mx-5 flex flex-col lg:flex-row  gap-1">
      <Card v-for="data in cardsData" :key="data.title" :data="data" class="w-full" />
    </div>
  </div>
</template>

<script>
import Card from './helpers/card.vue'

export default {
  components: {
    Card
  },
  data() {
    return {
      cardsData: [
        {
          title:'View inventory & prices',
          content: 'See which shipping container inventory options are available in your area.',
          icon: 'inventory',
          active: false
        },
        {
          title:'Choose the best deal',
          content: 'Choose which shipping container is best for your needs.',
          icon: 'deal-tag',
          active: false
        },
        {
          title:'Container is shipped!',
          content: 'Choose which shipping container is best for your needs.',
          icon: 'shipping-truck',
          active: false
        }
      ],
      currentIndex: 0
    }
  },
  mounted() {
    this.updateActiveCard()
    this.startLoop()
  },
  methods: {
    startLoop() {
      setInterval(() => {
        this.updateActiveCard()
      }, 20000) // 20 seconds interval
    },
    updateActiveCard() {
      this.cardsData.forEach(card => card.active = false)
      this.cardsData[this.currentIndex].active = true
      this.currentIndex = (this.currentIndex + 1) % this.cardsData.length
    }
  }
}
</script>

<style scoped>
.cover-cards-outer-container {
  padding-top: 48px
}

.cover-cards-container {
  background-color: #E0DAD1;
  border: 1px solid #E0DAD1;
  padding: 4px;
  border-radius: 12px;
}

/* Mobile */
@media (max-width: 1024px) {
  .cover-cards-outer-container {
    padding-top: 24px
  }
}
</style>
